namespace PaperTrail.Web.Modules.NewsletterControl.Newsletter {
    export interface PublishNewsletterResponse extends Serenity.ServiceResponse {
        ZipFileName?: string;
        NewsletterContent?: string;
        CacheId?: string;
    }
}
